import React from "react";
import { useWatchInput } from "../../hooks/useWatchInput";
import PropTypes from "prop-types";

const IncidentSubLocationSelect = ({ subLocationOptions, currentSubLocation, errors }) => {
  const incidentReportLocationValue = useWatchInput({ id: "incident_report_location" });

  if (incidentReportLocationValue !== "TED") return <></>;
  return (
    <div className="block ccw-field incident-form-field incident-form-sub-location">
      <label htmlFor="incident_report_sub_location" className="label ccw-field__label">
        Incident Sub Location
      </label>

      {errors && errors.length > 0 && (
        <div className="error-messages">
          {errors.map((error, index) => (
            <p key={index} className="help is-danger">
              {error}
            </p>
          ))}
        </div>
      )}

      <div className="select">
        <select
          id="incident_report_sub_location"
          name="incident_report[sub_location]"
          className="ccw-select"
          defaultValue={currentSubLocation}
        >
          <option value="">unknown</option>
          {subLocationOptions.map((option) => (
            <option key={option} value={option}>
              {option}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
};

IncidentSubLocationSelect.propTypes = {
  subLocationOptions: PropTypes.array,
  currentSubLocation: PropTypes.string,
  errors: PropTypes.array
};

export default IncidentSubLocationSelect;
